import { RefreshCw, Server, Shield, Zap } from "lucide-react";

export const ServerFleetHeader = ({ checkingHealth, fingerproxySyncing, onRefreshHealth, onSyncTls, servers }) => {
  const onlineCount = servers.filter((server) => server.is_online).length;
  const total = servers.length;
  const allOnline = total > 0 && onlineCount === total;

  return (
    <div className="border-b border-slate-800/80 pb-6" data-testid="server-fleet-header">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <div className="min-w-0 space-y-3">
          <span className="wx-tactical" data-testid="server-fleet-overline">
            <Server className="h-3 w-3" /> Infrastructure Operations
          </span>
          <div className="flex flex-wrap items-center gap-3">
            <h1 className="font-orbitron text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl" data-testid="redirect-servers-title">
              Redirect Servers
            </h1>
            <span
              className={`wx-chip ${allOnline ? "wx-chip-emerald" : onlineCount === 0 ? "wx-chip-rose" : "wx-chip-amber"}`}
              data-testid="server-fleet-online-count"
            >
              <span className={`h-1.5 w-1.5 rounded-full ${allOnline ? "bg-emerald-400 animate-pulse" : onlineCount === 0 ? "bg-rose-400" : "bg-amber-400"}`} />
              {onlineCount}/{total} online
            </span>
          </div>
          <p className="text-sm text-slate-400">Operate health, domains, TLS, and traffic across the redirect fleet.</p>
        </div>

        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
          <button
            type="button"
            onClick={onRefreshHealth}
            disabled={checkingHealth === "all" || !total}
            className="wx-btn border border-amber-500/30 bg-amber-500/10 text-amber-200 hover:bg-amber-500/20"
            title="Re-check live latency for every server"
            data-testid="refresh-all-health-btn"
          >
            {checkingHealth === "all" ? <RefreshCw className="h-4 w-4 animate-spin" /> : <Zap className="h-4 w-4" />}
            Refresh health
          </button>
          <button
            type="button"
            onClick={onSyncTls}
            disabled={fingerproxySyncing === "all" || !total}
            className="wx-btn-outline"
            data-testid="fingerproxy-sync-all-btn"
          >
            {fingerproxySyncing === "all" ? <RefreshCw className="h-4 w-4 animate-spin" /> : <Shield className="h-4 w-4" />}
            Sync TLS fleet
          </button>
        </div>
      </div>
    </div>
  );
};
